const AssetDevice = () => import('Views/asset/asset-device');

export default[
  { path: '/asset-device', component: AssetDevice },
];



// WEBPACK FOOTER //
// ./src/router/asset.js